
// eslint-disable-next-line
import LoaderIcon from '~/static/loading.svg?inline';

export default {
  name: 'LegacyLoading',
  components: {
    LoaderIcon,
  },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
